import { priceText } from "src/components/PriceTag"
import { mainImage } from "src/domain/boat"
import { Boat } from "../types/boat"
import { Offer } from "../types/offer"

export const extraStr = (extra: any, offer: Offer) =>
  `${extra.name}${offer ? `~|~${priceText(offer.currency, extra.price)}` : ""}~|~${extra.unit}`

export const boatDripData = (boat?: Boat, offer?: Offer, search?: Record<any, any>) => {
  const extras = (es: any, obligatory: boolean) => {
    if (!es || !offer || !Array.isArray(es)) return ""
    return es
      .filter((e) => e.obligatory === obligatory)
      .map((e) => extraStr(e, offer))
      .join("~||~")
  }

  return {
    boat_image: mainImage(boat) || "",
    boat_year: boat?.year || "",
    boat_cabins: boat?.cabins || "",
    boat_starting_location: boat?.base.address || "",
    boat_number_of_people: boat?.berthsTotal || "",
    check_in_date: search?.checkin || "",
    check_out_date: search?.checkout || "",
    total_price: offer?.startPrice || "",
    discount_price: offer?.discountedPrice || "",
    discount_percentage: offer?.discountPercentage || "",
    booking_mananger_link: `https://portal.booking-manager.com/wbm2/page.html?view=YachtDetails&yachtId=${boat?.id}&addMargins=true&setlang=en`,
    boat_name: boat?.name || "",
    model: `${boat?.brand} - ${boat?.modelName}`,
    website: boat?.cardImageSrc || "",
    mandatory_extras: extras(boat?.extras, true).substring(0, 999),
    optional_extras: extras(boat?.extras, false).substring(0, 999),
  }
}
export const getTop3BoatData = (offers?: Offer[], search?: any) => {
  return offers?.slice(0, 3).reduce(
    (data, offer, i) => {
      Object.assign(data, {
        [`boat_${i}_boat_name`]: offer.boat.name || "",
        [`boat_${i}_boat_model`]: offer.boat.modelName || "",
        [`boat_${i}_image`]: mainImage(offer.boat) || "",
        [`boat_${i}_year`]: offer.boat.year || "",
        [`boat_${i}_cabins`]: offer.boat.cabins || "",
        [`boat_${i}_total_price`]: offer?.startPrice || "",
        [`boat_${i}_discount_price`]: offer?.discountedPrice || "",
        [`boat_${i}_discount_percentage`]: offer?.discountPercentage || "",
        [`boat_${i}_booking_mananger_link`]: `https://portal.booking-manager.com/wbm2/page.html?view=YachtDetails&yachtId=${offer.boat.id}&addMargins=true&setlang=en`,
      })
      return data
    },
    {
      check_in_date: search?.checkin || "",
      check_out_date: search?.checkout || "",
    } as any
  )
}
